export default "__VITE_ASSET__BZM8PL7g__"